import { useRef, useState } from "react";
import { formatPartyAddress, visibleGst } from "../orders/orderParty";

/** The party AddParty just saved, in the shape the memo party picker uses. */
export const partyFromConnect = (res: any) => {
  const org = res?.data || {};
  const id = String(org._id || org.id || "").trim();
  const name = String(org.name || "").trim();
  if (!id || !name) {
    return null;
  }
  return {
    id,
    name,
    phone: String(org.phone || "").trim(),
    gst: visibleGst(org.GST || org.gst),
    address: formatPartyAddress(org.address),
  };
};

/** GST / phone suggestions for the AddParty modal (debounced organisation search). */
export const useGstOptions = (getOrganisation: (params: any, done: (res: any) => void) => void) => {
  const wait = useRef<number | null>(null);
  const [gstOptions, setGstOptions] = useState<any[]>([]);
  const handleOnInputChangeFilters = (type: any) => {
    if (wait.current) {
      window.clearTimeout(wait.current);
    }
    const value = String(type?.value || type?.phone || "").trim();
    if (value.length < 2) {
      return;
    }
    wait.current = window.setTimeout(() => {
      getOrganisation(
        {
          offset: 0,
          limit: 10,
          gst: type?.name === "gst" ? value : undefined,
          phone: type?.name === "phone" ? value : undefined,
        },
        (res: any) => {
          const docs = res?.data?.docs || [];
          setGstOptions(
            docs.map((ele: any) => ({
              label:
                (ele?.gst?.length > 0 ? ele.gst.toUpperCase() : "N/A") +
                "(" +
                ele?.name +
                ")" +
                "(" +
                ele?.phone +
                ")",
              value: {
                gst: ele?.gst,
                phone: ele?.phone,
              },
            }))
          );
        }
      );
    }, 400);
  };
  return { gstOptions, handleOnInputChangeFilters };
};
